import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { agentApi, apiErrorMessage } from '../services/agentApi';

/**
 * Landing page for the forwarding-address verification email. Verifies on a
 * button click, not on load: mail security scanners (Microsoft Safe Links)
 * open links in a real browser, and auto-verifying on load let a scanner
 * spend the token before the person ever clicked.
 */
const AgentVerifyAlias: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState<{ ok?: string; already?: boolean; error?: string } | null>(null);

  const verify = () => {
    setBusy(true);
    agentApi
      .verifyAlias(token)
      .then((r) => setState({ ok: r.email, already: !!r.alreadyVerified }))
      .catch((err) => setState({ error: apiErrorMessage(err, 'This verification link is invalid.') }))
      .finally(() => setBusy(false));
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="w-full max-w-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg shadow p-6 text-center">
        <div className="text-primary font-semibold">RiskNinja Agent Mailbox</div>
        {!state && (
          <>
            <p className="mt-4 text-sm text-gray-600 dark:text-gray-300">Confirm this address as one you forward email from. Email sent from it to the agent mailbox will be handled as you.</p>
            <button
              onClick={verify}
              disabled={busy || !token}
              className="mt-4 px-4 py-2 rounded-md bg-primary text-white text-sm font-medium hover:bg-primary/90 disabled:opacity-50"
            >
              {busy ? 'Verifying…' : 'Verify this address'}
            </button>
          </>
        )}
        {state?.ok && (
          <p className="mt-4 text-sm text-green-700 dark:text-green-400">
            {state.ok} is {state.already ? 'already ' : ''}verified. Email you forward from it to the agent mailbox is handled as you.
          </p>
        )}
        {state?.error && <p className="mt-4 text-sm text-red-600 dark:text-red-400">{state.error}</p>}
        <Link to="/agent?tab=settings" className="inline-block mt-4 text-sm text-primary hover:underline">Agent settings →</Link>
      </div>
    </div>
  );
};

export default AgentVerifyAlias;
